module.exports = __webpack_public_path__ + "img/videoPoster3.4a25be65.jpg";